import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DecodedToken, LastLoggedInUser } from '@core/models';
import { Observable } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { WishListState } from '@ngxs-store/wish-list-store/wish-list.state';
import { CartModel } from '@core/models/cart';
import { CartState } from '@ngxs-store/cart/cart.state';
import { ClearCartStateAction, ClearItemsFromCartAction, RemoveItemFromCartAction } from '@ngxs-store/cart/cart.actions';
import { RemoveItemFromCartCommand, WishlistModel } from '@core/services/api.service';
import { ClearLastUserAction, ClearTokenAction } from '@ngxs-store/auth-store/auth.actions';
import { ClearWishListStateAction } from '@ngxs-store/wish-list-store/wish-list.actions';
import { Navigate } from '@ngxs/router-plugin';
import { SearchState } from '@ngxs-store/search-store/search.state';
import { NavComponent } from '../nav/nav.component';

@Component({
    selector: 'app-shared-header',
    templateUrl: './shared-header.component.html',
    styleUrls: ['./shared-header.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class SharedHeaderComponent {
    @Input() isHomePage: boolean = false;
    @Input() imageUrl: string;
    @Input() decodedToken: DecodedToken;
    @Input() hasValidToken: boolean;
    @Input() cart: CartModel;
    @Input() wishList: WishlistModel;
    @Output() clearCartClick = new EventEmitter();
    @Select(CartState.Cart) cartProducts$: Observable<CartModel>;
    @Select(WishListState.getItems) len$: Observable<WishlistModel>;
    @Select(CartState.getTotalPriceIncl) totalPrice: Observable<number>;
    @Select(CartState.getNoOfItems) noOfItems: Observable<number>;
    @Select(WishListState.getNoOfItems) noOfItemsWishlist: Observable<number>;
    @Select(SearchState.searchText) searchText$: Observable<string>;
    @ViewChild(NavComponent) navComponent: NavComponent;

    constructor(private _route: ActivatedRoute, private _router: Router, private store: Store) { }

    logout() {
        this.store.dispatch(new ClearLastUserAction());
        this.store.dispatch(new ClearTokenAction());
        this.store.dispatch(new ClearCartStateAction());
        this.store.dispatch(new ClearWishListStateAction());
        this.store.dispatch(new Navigate(['/featured']));
        this.navComponent.logoutRefresh();
    }

    openMenu(event) {
        const nav = document.querySelectorAll('#responsive-nav');
        nav.forEach(nav => {
            nav.classList.add('active');
        });
    }
    removeFromCart(product) {
        this.store.dispatch(new RemoveItemFromCartAction({
            command: new RemoveItemFromCartCommand({
                skuCode: product.productId,
                remove: true
            })
        }));
    }
}
